import React from 'react'
import { Icon } from '@/components/dumb/Icon'
import { LinkWithIcon } from '../LinkWithIcon'
import { LinkWithIconProps } from '../LinkWithIcon/props'

export const BackLink: React.FC<Omit<LinkWithIconProps, 'icon'>> = (props) => {
  return <LinkWithIcon icon={<Icon type="back_arrow" />} {...props} />
}
